module.exports = __webpack_public_path__ + "media/images/icon-userinfo@3x-e6fb584d04b925f312a8fbd9cebc6cae.png";